import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import SbGameCommon from '~/core';
import { WSocket } from '~/classes';
import { ENV } from '~/enum/env';
import { EventWS } from '~/enum/ws';
import { EventItem, TotalBettingAndTotalUserTeamField } from '~/enum/event';
import { DeviceType, TeamType } from '~/enum';
import { logger } from '~/classes/Logger';
const Canvas = ({ bannerVoltaModelSingleton, event, device = DeviceType.Mobile, onClick = () => { }, callbackReset = () => { }, }) => {
    const BannerVoltaModelSingleton = bannerVoltaModelSingleton.current;
    const [internalError, setInternalError] = useState(null);
    const containerRef = useRef(null);
    const stageRef = useRef();
    const groupRef = useRef();
    const layerRef = useRef();
    const wssClientRef = useRef(null);
    const matchItemRef = useRef(event);
    const isWonRef = useRef(!!(event === null || event === void 0 ? void 0 : event[EventItem.TeamWinning]));
    if (internalError)
        throw internalError;
    const sceneSize = device === DeviceType.Mobile
        ? {
            width: 378,
            height: 60,
        }
        : {
            width: 1146,
            height: 120,
        };
    const renderElement = () => {
        if (!containerRef.current ||
            !stageRef.current ||
            !layerRef.current ||
            !groupRef.current ||
            !BannerVoltaModelSingleton) {
            logger.error('Canvas not initialized properly');
            return;
        }
        if (!event) {
            BannerVoltaModelSingleton.renderNotMatch();
        }
        else {
            BannerVoltaModelSingleton.render(event);
        }
    };
    const getFieldTotalBettingAndUserBetting = (event) => {
        var _a, _b, _c, _d;
        return {
            homeTotalBetting: ((_a = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _a === void 0 ? void 0 : _a[TotalBettingAndTotalUserTeamField.HomeTotalBetting]) || 0,
            awayTotalBetting: ((_b = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _b === void 0 ? void 0 : _b[TotalBettingAndTotalUserTeamField.AwayTotalBetting]) || 0,
            homeTotalUser: ((_c = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _c === void 0 ? void 0 : _c[TotalBettingAndTotalUserTeamField.HomeTotalUser]) || 0,
            awayTotalUser: ((_d = event === null || event === void 0 ? void 0 : event[EventItem.TotalBettingAndTotalUserTeam]) === null || _d === void 0 ? void 0 : _d[TotalBettingAndTotalUserTeamField.AwayTotalUser]) || 0,
        };
    };
    const compareTotalBettingAndUserBetting = (event, matchItem) => {
        if (!BannerVoltaModelSingleton)
            return;
        const currentTotals = getFieldTotalBettingAndUserBetting(event);
        const previousTotals = getFieldTotalBettingAndUserBetting(matchItem);
        if (currentTotals.homeTotalBetting !== previousTotals.homeTotalBetting ||
            currentTotals.homeTotalUser !== previousTotals.homeTotalUser) {
            BannerVoltaModelSingleton.updateTotalUserBetting(TeamType.HOME, currentTotals.homeTotalUser);
            BannerVoltaModelSingleton.updateTotalAmountBetting(TeamType.HOME, currentTotals.homeTotalBetting);
        }
        if (currentTotals.awayTotalBetting !== previousTotals.awayTotalBetting ||
            currentTotals.awayTotalUser !== previousTotals.awayTotalUser) {
            BannerVoltaModelSingleton.updateTotalUserBetting(TeamType.AWAY, currentTotals.awayTotalUser);
            BannerVoltaModelSingleton.updateTotalAmountBetting(TeamType.AWAY, currentTotals.awayTotalBetting);
        }
        matchItemRef.current = event;
    };
    const handleDataCurrent = (customEvent) => {
        var _a;
        try {
            if (!BannerVoltaModelSingleton) {
                logger.error('BannerVoltaModel is not initialized');
                return;
            }
            const data = customEvent.detail;
            const matchItem = matchItemRef.current;
            if (JSON.stringify(data) === JSON.stringify(matchItem)) {
                return;
            }
            if (!!data[EventItem.IsLive]) {
                if (!isWonRef.current && !!data[EventItem.ResultCode]) {
                    BannerVoltaModelSingleton.updateTeamWon(data[EventItem.TeamWinning]);
                    isWonRef.current = true;
                }
            }
            else {
                if (!matchItem) {
                    matchItemRef.current = data;
                    BannerVoltaModelSingleton.renderFirstMatch(data);
                    return;
                }
                if ((matchItem === null || matchItem === void 0 ? void 0 : matchItem[EventItem.EventId]) !== data[EventItem.EventId] &&
                    data[EventItem.EventId] > ((_a = matchItem === null || matchItem === void 0 ? void 0 : matchItem[EventItem.EventId]) !== null && _a !== void 0 ? _a : 0)) {
                    BannerVoltaModelSingleton.startNewMatch(data);
                    isWonRef.current = false;
                }
                compareTotalBettingAndUserBetting(data, matchItem);
            }
        }
        catch (error) {
            setInternalError(error instanceof Error ? error : new Error(String(error)));
        }
    };
    // Function to make the stage responsive
    function fitStageIntoParentContainer() {
        // Get the container element
        const container = containerRef.current;
        const stage = stageRef.current;
        // Make the container take up the full width
        container.style.width = '100%';
        // Get current container width
        const containerWidth = container.offsetWidth;
        // Calculate scale based on virtual width vs actual width
        const scale = Number(containerWidth / sceneSize.width);
        // Set stage dimensions and scale
        stage.width(sceneSize.width * scale);
        stage.height(sceneSize.height * scale);
        stage.scale({ x: scale, y: scale });
    }
    const handleEmptyMatch = (customEvent) => {
        var _a;
        const isNotMatch = (_a = customEvent.detail) === null || _a === void 0 ? void 0 : _a.isNotMatch;
        if (BannerVoltaModelSingleton && isNotMatch) {
            BannerVoltaModelSingleton.renderNotMatch();
            isWonRef.current = false;
            matchItemRef.current = null;
        }
    };
    const onHandleClick = () => {
        onClick();
    };
    useEffect(() => {
        window.addEventListener(EventWS.webSocketEventList, handleDataCurrent);
        window.addEventListener(EventWS.webSocketEventListNotMatch, handleEmptyMatch);
        window.addEventListener('resize', fitStageIntoParentContainer);
        return () => {
            window.removeEventListener(EventWS.webSocketEventList, handleDataCurrent);
            window.removeEventListener(EventWS.webSocketEventListNotMatch, handleEmptyMatch);
            window.removeEventListener('resize', fitStageIntoParentContainer);
        };
    }, []);
    useEffect(() => {
        try {
            if (BannerVoltaModelSingleton) {
                const dpr = 1;
                const stage = new SbGameCommon.Stage({
                    container: containerRef.current,
                    width: sceneSize.width * dpr,
                    height: sceneSize.height * dpr,
                    // pixelRatio: dpr,
                });
                stageRef.current = stage;
                const layer = new SbGameCommon.Layer();
                layerRef.current = layer;
                const group = new SbGameCommon.Group();
                groupRef.current = group;
                group.setAttrs({
                    x: 0,
                    y: 0,
                    width: stage.width,
                    height: stage.height,
                });
                layer.add(group);
                stage.add(layer);
                BannerVoltaModelSingleton.setupStageLayerGroup(stageRef.current, layerRef.current, groupRef.current);
                BannerVoltaModelSingleton.init();
                renderElement();
            }
            wssClientRef.current = new WSocket(ENV.WSocket, {
                debug: true,
            });
            wssClientRef.current.connect();
            fitStageIntoParentContainer();
        }
        catch (error) {
            setInternalError(error instanceof Error ? error : new Error(String(error)));
        }
        return () => {
            var _a;
            (_a = stageRef === null || stageRef === void 0 ? void 0 : stageRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
            if (wssClientRef.current) {
                wssClientRef.current.cleanup();
            }
            matchItemRef.current = undefined;
            isWonRef.current = false;
            stageRef.current = undefined;
            groupRef.current = undefined;
            layerRef.current = undefined;
            wssClientRef.current = null;
            callbackReset();
        };
    }, []);
    useEffect(() => {
        if (stageRef.current) {
            stageRef.current.on('click tap', onHandleClick);
        }
        return () => {
            if (stageRef.current) {
                stageRef.current.off('click tap', onHandleClick);
            }
        };
    }, [stageRef.current]);
    return _jsx("div", { ref: containerRef });
};
export default Canvas;
